import type { TranslateFn } from "./i18n/store.js";

/**
 * What to show for a failed API call. A 429 — a rate limit or a quota (saves
 * per minute, reports per day, …) — gets the translated "too many attempts"
 * line, since the server's own sentence is English; anything else keeps the
 * error's message, then `fallback`.
 *
 * Reads the status off the error (apiClient's ApiError carries it) rather than
 * testing `instanceof ApiError`, so a page whose tests replace apiClient with a
 * partial mock still shows its error instead of throwing in its catch.
 */
export function apiErrorMessage(error: unknown, t: TranslateFn, fallback: string): string {
  if (!(error instanceof Error)) return fallback;
  if ((error as { status?: unknown }).status === 429) return t("common.tooManyRequests");
  return error.message;
}
